import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb34da7a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb34da7a')) {
      api.createRecord('cb34da7a', component.options)
    } else {
      api.reload('cb34da7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb34da7a", function () {
      api.rerender('cb34da7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/cooperative/index.vue"
export default component.exports